import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SwitchCasesDirective } from '@core/directives/SwitchCases.directive';

@Component({
  selector: 'app-fileimagepreview',
  standalone: true,
  imports: [
    CommonModule,
    SwitchCasesDirective,
  ],
  templateUrl: './fileimagepreview.component.html',
  styleUrl: './fileimagepreview.component.scss'
})
export class FileimagepreviewComponent {
  @Input() fileType: string | null = null;
}
